import dayjs from 'dayjs'

export const COMPETITIONS_BOTTOM_BAR_CONFIG = {
    MAX_ITEMS: 6,
    FAVORITE: {
        LOCAL_STORAGE_KEY: 'favoriteComps.v2',
    },
    IGNORED_MOBILE_LIVE_MATCH: {
        LOCAL_STORAGE_KEY: 'ignoredLiveMatch.v1',
        MAX_ITEMS: 10,
    },
    LAST_VIEWED: {
        LOCAL_STORAGE_KEY: 'lastViewedComps.v1',
        MAX_ITEMS: 10,
    },
    /**
     * favorite + last viewed
     */
    USER_COMPS: {
        LOCAL_STORAGE_KEY: 'userComps.v2',
        EXPIRATION: {
            LOCAL_STORAGE_KEY: 'userCompsExpire.v2',
            getNewExpiration: () => dayjs.utc().endOf('day').toISOString(),
        },
    },
    COUPES: {
        SESSION_STORAGE_KEY: 'currentCoupes.v1',
    },
}
